<div>
  <div class="mb-3 text-center">
    <span class="fw-bold fs-6">{{ comments.length ? 'Comentarios':'No se han registrado comentarios'}}</span>
  </div>
  <div class="content-comments">
    <div *ngFor="let commnet of comments">
      <div class="mb-3">
        <div>
          <span class="fs-6 fw-regular">{{commnet?.comentario}}</span>
        </div>
        <div class="text-end">
          <span class="fs-7 text-gray">{{getDateFormated(commnet?.registrado)}}</span>
        </div>
      </div>
    </div>
  </div>
  <br>
  <button mat-flat-button class="bg-blue-2 w-100" (click)="addComment()">
    <img src="assets/svg/Icon_editar_small.svg" width="24" class="me-3" alt="">
    <span class="fw-regular fs-6 text-white me-3">Ingresar comentario</span>
  </button>
</div>